module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "foot"
  }, [(_vm.showShareNote && _vm.activeNote) ? _c('bar-share-note', {
    on: {
      "onDone": _vm.onShareNote
    }
  }) : _c('bar-actions', {
    on: {
      "onShareNote": _vm.onShareNote
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6312ad66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bar/Index.vue
// module id = 2155
// module chunks = 0